export enum ServiceType {
  ClassicManager = "CM",
  MusicForShop = "M4S",
  DataVoucher = "EXTERNAL",
  CoverLala = "COVERLALA"
}
